import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import {  
  Autocomplete,
  Popover,
  Button,
  Stack,
  TextField,
  Container,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Paper
} from '@mui/material';


// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroKit = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState({ativo: [true,null]})
  

  const handleCheckboxChange = (index) => {
    // Crie uma cópia do objeto filtro para evitar mutação direta
    const novoFiltro = { ...filtro };
    if(index === 0 ){
      if(novoFiltro.ativo[index]){
        novoFiltro.ativo[index] = null
      } else{
        novoFiltro.ativo[index] = true
      }
    }
    if(index === 1 ){
      if(novoFiltro.ativo[index] !== null){
        novoFiltro.ativo[index] = null
      } else{
        novoFiltro.ativo[index] = false
      }
        
    }
    setFiltro(novoFiltro);
    handleConfirm(novoFiltro)
  };

  const handleConfirm = (novoFiltro) => {
    props.onConfirm(novoFiltro)
    
  }  
  return (


    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '20%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{height: 'auto'}}>
        
  
          <Paper>
            <List>

                <ListItem key={'ativo'} dense onClick={() => handleCheckboxChange(0)}>
                  <Checkbox
                    edge="start"
                    checked={filtro.ativo[0] !== null}
                    tabIndex={-1}
                    disableRipple
                  />
                  <ListItemText primary={'Ativos'} />
                </ListItem>

                <ListItem key={'inativo'} dense onClick={() => handleCheckboxChange(1)}>
                  <Checkbox
                    edge="start"
                    checked={filtro.ativo[1] !== null}
                    tabIndex={-1}
                    disableRipple
                  />
                  <ListItemText primary={'Inativos'} />
                </ListItem>

            </List>
          </Paper>
    
        

      </Stack>
      
    </Popover>
  );
})

PopoverFiltroKit.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func
}

export default (PopoverFiltroKit);